import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3befd1aa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3befd1aa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3befd1aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3befd1aa')) {
      api.createRecord('3befd1aa', component.options)
    } else {
      api.reload('3befd1aa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3befd1aa&scoped=true", function () {
      api.rerender('3befd1aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/after/csg-admin-return/index.vue"
export default component.exports